// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-ManageTB-Features-styles___paper--AZOyl {
  padding: 32px;
  max-width: 736px;
  margin: 0 auto 30px;
  margin-left: 0;
  width: 100%;
  padding-bottom: 20px;
}

.components-ManageTB-Features-styles___dropdown--cpgxD {
  padding: 15px;
  max-width: 736px;
}

.components-ManageTB-Features-styles___root--bBigH {
  width: 100%;
}

.components-ManageTB-Features-styles___menuItem--jKjEk {
  font-size: 15px;
  color: #1b2432 !important;
  line-height: 18px;
}

.components-ManageTB-Features-styles___listItem--wgWHA {
  height: auto !important;
  padding-top: 8px;
  padding-bottom: 8px;
}

.components-ManageTB-Features-styles___location--CzLyv {
  margin-bottom: 5px;
}

.components-ManageTB-Features-styles___inputContainer--C1XVB {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 32px;
}

.components-ManageTB-Features-styles___inputContainer--C1XVB.components-ManageTB-Features-styles___passportInfo--vmN46 {
    padding-bottom: 24px;
  }

.components-ManageTB-Features-styles___inputContainer--C1XVB.components-ManageTB-Features-styles___inputContainerTravelerSelection--sWOjR {
    padding: 16px 0 0;
    border-bottom: none;
    padding-top: 0;
  }

.components-ManageTB-Features-styles___inputContainer--C1XVB.components-ManageTB-Features-styles___inputContainerTravelerSelectionOpen--bbEwJ {
    padding: 0 0 32px 0;
  }

.components-ManageTB-Features-styles___inputContainer--C1XVB.components-ManageTB-Features-styles___wrapperContainer--tIrOI {
    border-top: 1px solid #dddee0;
    flex-direction: column;
    padding-top: 32px;
  }

.components-ManageTB-Features-styles___inputContainer--C1XVB.components-ManageTB-Features-styles___wrapperContainer--tIrOI .components-ManageTB-Features-styles___subtitle--yw9_W {
      color: #6d717a;
      font-size: 15px;
      padding: 6px 0 16px;
    }

.components-ManageTB-Features-styles___inputContainer--C1XVB.components-ManageTB-Features-styles___wrapperContainer--tIrOI .components-ManageTB-Features-styles___radioGroupLabel--Xonw8 {
      font-weight: 400;
    }

.components-ManageTB-Features-styles___secondarySelectInput--Z94FV {
  display: flex;
  align-items: center;
}

.components-ManageTB-Features-styles___inputWrapper--QpD2r {
  flex: 49% 0 1;
  padding: 8px 0 0;
}

.components-ManageTB-Features-styles___inputInVisible--_xU0j {
  display: none;
}

.components-ManageTB-Features-styles___inputWrapper_department--dtgx3 {
  flex: 49% 0 1;
  padding: 8px 0 0;
}

.components-ManageTB-Features-styles___inputWrapper_department--dtgx3 div label {
    z-index: 0;
  }

.components-ManageTB-Features-styles___table--oq7ht {
  margin: 20px 0 0;
}

.components-ManageTB-Features-styles___tableHead--kZFAp {
  color: #1b2432 !important;
  font-weight: 500 !important;
  font-size: 15px !important;
}

.components-ManageTB-Features-styles___tableHead--kZFAp:nth-child(2) {
  padding: 16px 4px 16px 0 !important;
}

.components-ManageTB-Features-styles___tableRow--rlwh3 {
  height: 68px !important;
}

.components-ManageTB-Features-styles___tableRow--rlwh3:last-child .components-ManageTB-Features-styles___tableCell--Aqfkg {
      border: none;
    }

.components-ManageTB-Features-styles___tableRow--rlwh3.components-ManageTB-Features-styles___addNewTableRow--w52nI {
    border-bottom: 1px solid rgba(224, 224, 224, 1);
  }

.components-ManageTB-Features-styles___tableCell--Aqfkg {
  font-size: 15px !important;
  padding: 16px 16px 16px 24px !important;
  min-width: unset !important;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 400px;
}

.components-ManageTB-Features-styles___tableCell--Aqfkg.components-ManageTB-Features-styles___removeCell--GV4uw {
    text-align: right;
    padding: 0 !important;
    width: 100px;
    cursor: pointer;
  }

.components-ManageTB-Features-styles___tableCell--Aqfkg.components-ManageTB-Features-styles___removeCell--GV4uw button {
      padding-left: 0;
      padding-right: 0;
    }

.components-ManageTB-Features-styles___tableCell--Aqfkg.components-ManageTB-Features-styles___removeCell--GV4uw .components-ManageTB-Features-styles___button_more--GGzOE {
      min-width: 10px;
    }

.components-ManageTB-Features-styles___tableCell--Aqfkg.components-ManageTB-Features-styles___removeCell--GV4uw .components-ManageTB-Features-styles___button_more--GGzOE:hover {
      background-color: transparent !important;
    }

.components-ManageTB-Features-styles___tableCell--Aqfkg.components-ManageTB-Features-styles___removeCell--GV4uw .components-ManageTB-Features-styles___menuList--NiVao {
      font-size: 15px;
      letter-spacing: 0;
    }

.components-ManageTB-Features-styles___tableCell--Aqfkg.components-ManageTB-Features-styles___removeCell--GV4uw .components-ManageTB-Features-styles___menuList--NiVao li:first-child {
        font-size: 15px;
        color: #6d717a !important;
      }

.components-ManageTB-Features-styles___tableCell--Aqfkg.components-ManageTB-Features-styles___removeCell--GV4uw .components-ManageTB-Features-styles___menuList--NiVao li:nth-child(3) {
        font-size: 15px;
        color: #fc3b60 !important;
      }

.components-ManageTB-Features-styles___tableCell--Aqfkg.components-ManageTB-Features-styles___removeCell--GV4uw .components-ManageTB-Features-styles___menuList--NiVao svg {
        margin-right: 5px;
      }

.components-ManageTB-Features-styles___tableCell--Aqfkg.components-ManageTB-Features-styles___inputTableCell--pET7b {
    padding: 16px 16px 16px 0 !important;
    width: 250px;
  }

.components-ManageTB-Features-styles___tableCell--Aqfkg.components-ManageTB-Features-styles___inputTableCell--pET7b > div {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }

.components-ManageTB-Features-styles___tableCell--Aqfkg.components-ManageTB-Features-styles___buttonTableCell--_yj_c {
    padding: 16px 0 !important;
    text-align: right;
    width: 160px;
  }

.components-ManageTB-Features-styles___tableCell--Aqfkg:nth-child(2) {
  padding: 16px 16px 16px 0 !important;
}

.components-ManageTB-Features-styles___alertMessageCont--wAZdk {
  display: flex;
  flex-direction: column;
}

.components-ManageTB-Features-styles___alertMessageCont--wAZdk .components-ManageTB-Features-styles___alertMessage--Pni2j {
    font-family: 'Roboto-Regular';
    font-size: 11px;
    color: #fc3b60 !important;
    letter-spacing: 0;
    margin-top: 4px;
  }

.components-ManageTB-Features-styles___emptyData--K2dFj {
  padding: 24px 0;
}

.components-ManageTB-Features-styles___selectWrapper--t5J5V {
  width: 100%;
}

.components-ManageTB-Features-styles___cancel--xQZ68 {
  color: #6d717a;
  margin-right: 12px;
}

.components-ManageTB-Features-styles___addHotel--xk6Ks {
  display: flex;
  align-items: center;
  color: #1e8aff !important;
  font-size: 13px;
  padding: 6px 0 18px 24px;
  cursor: pointer;
}

.components-ManageTB-Features-styles___addHotel--xk6Ks:hover {
    color: #f6f6f7;
  }

.components-ManageTB-Features-styles___addHotel--xk6Ks {
  width: 100%;
  font-weight: 500;
}

.components-ManageTB-Features-styles___addIcon--FPHr_ {
  height: 18px;
  margin-right: 5px;
}

.components-ManageTB-Features-styles___close--tJjiJ {
  cursor: pointer;
  display: none;
}

.components-ManageTB-Features-styles___close--tJjiJ .components-ManageTB-Features-styles___icon--_3u56 {
    color: rgba(0, 0, 0, 0.23);
    font-size: 16px;
    margin-right: 2px;
  }

.components-ManageTB-Features-styles___loaderContainer--WxFH9 {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.2);
}

.components-ManageTB-Features-styles___iconAndInfoContainer--cdXqW {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
}

.components-ManageTB-Features-styles___iconAndInfoContainer--cdXqW .components-ManageTB-Features-styles___iconContainer--mt1PJ {
    margin-right: 24px;
    margin-top: 4px;
  }

.components-ManageTB-Features-styles___iconAndInfoContainer--cdXqW .components-ManageTB-Features-styles___iconContainer--mt1PJ .components-ManageTB-Features-styles___icon--_3u56 {
      width: 32px;
      height: 32px;
    }

.components-ManageTB-Features-styles___iconAndInfoContainer--cdXqW .components-ManageTB-Features-styles___titleStyle--r5mfc {
    font-family: 'Roboto';
    font-weight: 500;
    font-size: 21px;
    color: #1b2432;
    letter-spacing: 0;
    margin-bottom: 7px;
    text-align: start;
  }

.components-ManageTB-Features-styles___iconAndInfoContainer--cdXqW .components-ManageTB-Features-styles___subtitleStyle--d49nK {
    font-family: 'Roboto';
    font-weight: 400;
    font-size: 13px;
    color: #6d717a;
    letter-spacing: 0;
  }

.components-ManageTB-Features-styles___buttonContainer--KySqz {
  display: flex;
  justify-content: flex-end;
}

.components-ManageTB-Features-styles___userNameAndActionbuttonContaner--ocppI {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.components-ManageTB-Features-styles___noBorder--LRnl5 fieldset {
    border: none !important;
  }

.components-ManageTB-Features-styles___noBorder--LRnl5 {
  margin: 0 !important;
}

.components-ManageTB-Features-styles___noBorder--LRnl5 div {
    padding: 0 !important;
    padding-left: 1px !important;
    font-size: 17px;
    font-weight: 600;
  }

.components-ManageTB-Features-styles___popupButtonsContainer--cQNTR {
  border-top: 1px solid #e0e2e6;
  padding-top: 30px;
  display: flex;
  justify-content: flex-end;
}

.components-ManageTB-Features-styles___popupButtonsContainer--cQNTR button {
    width: 150px;
    height: 52px;
    font-size: 17px;
  }

.components-ManageTB-Features-styles___popupButtonsContainer--cQNTR button:first-child {
    border: 1px solid #318afb !important;
    border-radius: 6px;
    font-size: 17px;
    color: #318afb;
    letter-spacing: 0;
    text-align: center;
    margin-right: 15px;
  }

.components-ManageTB-Features-styles___popupButtonsContainer--cQNTR .components-ManageTB-Features-styles___cancelButton--NYFIV {
    border: 1px solid #318afb;
    border-radius: 6px;
    font-size: 17px;
    color: #318afb;
    letter-spacing: 0;
    text-align: center;
    margin-right: 15px;
  }

.components-ManageTB-Features-styles___addNewTableRowHotel--Rz2dC {
  margin-top: 20px;
}

.components-ManageTB-Features-styles___addHotelButtonLabel--apYVG {
  font-family: 'Roboto';
  font-size: 13px;
  color: #318afb;
  letter-spacing: 0;
  font-weight: 600;
}

.components-ManageTB-Features-styles___hotelTable--TfGJJ td {
    font-family: 'Roboto';
  }

.components-ManageTB-Features-styles___hotelTable--TfGJJ td:first-child {
    font-weight: 600;
  }

.components-ManageTB-Features-styles___item1--hKv6x {
  display: flex;
}

.components-ManageTB-Features-styles___pageWrapper--Qp1qV {
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
}

.components-ManageTB-Features-styles___tableCellFeature--Lrdes:nth-child(2) p {
    margin: 0 !important;
  }

td p {
    margin: 0 !important;
  }

.components-ManageTB-Features-styles___preview--AEreF {
  border: 1px solid #dddee0;
  padding: 6px;
  width: 66px;
  border-radius: 4px;
  font-size: 13px;
  width: -moz-fit-content;
  width: fit-content;
}

.components-ManageTB-Features-styles___test--EdDDf {
  border: 1px solid #dddee0;
  padding: 6px;
  width: 66px;
  border-radius: 6px;
  border-radius: 4px;
  font-size: 13px;
  background: rgba(252, 59, 59, 0.1);
  width: -moz-fit-content;
  width: fit-content;
}

.components-ManageTB-Features-styles___production--IXpcN {
  background: rgba(18, 218, 159, 0.1);
  border: 1px solid #12da9f;
  border-radius: 4px;
  font-size: 13px;
  color: #1b2432;
  letter-spacing: 0;
  text-align: center;
  padding: 6px;
  width: -moz-fit-content;
  width: fit-content;
}

.components-ManageTB-Features-styles___pending--zqyQ4 {
  background: rgba(247, 158, 61, 0.1);
  border: 1px solid #f79e3d;
  border-radius: 4px;
  font-size: 13px;
  color: #1b2432;
  letter-spacing: 0;
  text-align: center;
  padding: 6px;
  width: -moz-fit-content;
  width: fit-content;
}

.components-ManageTB-Features-styles___development--cfD78 {
  background: rgba(252, 59, 59, 0.1);
  border: 1px solid #fc3b60;
  border-radius: 4px;
  font-size: 13px;
  color: #1b2432;
  letter-spacing: 0;
  text-align: center;
  padding: 6px;
  width: -moz-fit-content;
  width: fit-content;
  background: rgba(252, 59, 59, 0.1);
}

.components-ManageTB-Features-styles___staging--nmJAA {
  border-radius: 4px;
  font-size: 13px;
  color: #1b2432;
  letter-spacing: 0;
  text-align: center;
  padding: 6px;
  width: -moz-fit-content;
  width: fit-content;
  background: rgba(247, 158, 61, 0.1);
  border: 1px solid #f79e3d;
}

.components-ManageTB-Features-styles___emptyHead--Ulnwx {
  width: 30px;
  padding: 0 !important;
  min-width: unset !important;
}

.components-ManageTB-Features-styles___empty--VJcmt {
  width: 30px;
  padding: 0 !important;
  border-bottom: none !important;
  min-width: unset !important;
}

.components-ManageTB-Features-styles___tableHeadFeature--Dj3VD {
  border-bottom: 2px solid #e0e2e6;
  box-shadow: 0 2px 4px 0 rgba(109, 113, 122, 0.15);
  font-size: 13px;
  color: #1b2432;
  letter-spacing: 0;
}

.components-ManageTB-Features-styles___editFeatureButton--gWzoN {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./components/ManageTB/Features/styles.pcss","<no source>"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,oBAAoB;AA+BtB;;AA7BE;IACE,oBAAoB;EACtB;;AAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;EAChB;;AAEA;IACE,mBAAmB;EACrB;;AAEA;IACE,6BAA6B;IAC7B,sBAAsB;IACtB,iBAAiB;EAWnB;;AATE;MACE,cAAc;MACd,eAAe;MACf,mBAAmB;IACrB;;AAEA;MACE,gBAAgB;IAClB;;AAIJ;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AACA;EACE,aAAa;EACb,gBAAgB;AAKlB;;AAHE;IACE,UAAU;EACZ;;AAGF;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;AAWzB;;AARI;MACE,YAAY;IACd;;AAGF;IACE,+CAA+C;EACjD;;AAGF;EACE,0BAA0B;EAC1B,uCAAuC;EACvC,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAwDlB;;AAtDE;IACE,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,eAAe;EAiCjB;;AA/BE;MACE,eAAe;MACf,gBAAgB;IAClB;;AAEA;MACE,eAAe;IACjB;;AAEA;MACE,wCAAwC;IAC1C;;AAEA;MACE,eAAe;MACf,iBAAiB;IAenB;;AAbE;QACE,eAAe;QACf,yBAAyB;MAC3B;;AAEA;QACE,eAAe;QACf,yBAAyB;MAC3B;;AAEA;QACE,iBAAiB;MACnB;;AAIJ;IACE,oCAAoC;IACpC,YAAY;EAMd;;AAJE;MACE,wBAAwB;MACxB,2BAA2B;IAC7B;;AAGF;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,YAAY;EACd;;AAGF;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;AASxB;;AAPE;IACE,6BAA6B;IAC7B,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;EACjB;;AAGF;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,wBAAwB;EACxB,eAAe;AAMjB;;AALE;IACE,cAAc;EAChB;;AChOF;EDiOE,WAAW;EACX;CClOF;;ADqOA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;AAOf;;AALE;IACE,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;EACnB;;AAGF;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,8BAA8B;AA4BhC;;AA1BE;IACE,kBAAkB;IAClB,eAAe;EAMjB;;AAJE;MACE,WAAW;MACX,YAAY;IACd;;AAGF;IACE,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;EACnB;;AACA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;AAGF;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAGE;IACE,uBAAuB;EACzB;;AChTF;EDiTE;CCjTF;;ADmTE;IACE,qBAAqB;IACrB,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;EAClB;;AAGF;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;EACb,yBAAyB;AA0B3B;;AAzBE;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;AAEA;IACE,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;AAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;AAGF;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAGE;IACE,qBAAqB;EACvB;;AACA;IACE,gBAAgB;EAClB;;AAGF;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,2CAA2C;AAC7C;;AAGE;IACE,oBAAoB;EACtB;;AAIA;IACE,oBAAoB;EACtB;;AAGF;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,uBAAkB;EAAlB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,uBAAkB;EAAlB,kBAAkB;EAClB,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,iDAAiD;EACjD,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".paper {\n  padding: 32px;\n  max-width: 736px;\n  margin: 0 auto 30px;\n  margin-left: 0;\n  width: 100%;\n  padding-bottom: 20px;\n}\n\n.dropdown {\n  padding: 15px;\n  max-width: 736px;\n}\n\n.root {\n  width: 100%;\n}\n\n.menuItem {\n  font-size: 15px;\n  color: #1b2432 !important;\n  line-height: 18px;\n}\n\n.listItem {\n  height: auto !important;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.location {\n  margin-bottom: 5px;\n}\n\n.inputContainer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding-bottom: 32px;\n\n  &.passportInfo {\n    padding-bottom: 24px;\n  }\n\n  &.inputContainerTravelerSelection {\n    padding: 16px 0 0;\n    border-bottom: none;\n    padding-top: 0;\n  }\n\n  &.inputContainerTravelerSelectionOpen {\n    padding: 0 0 32px 0;\n  }\n\n  &.wrapperContainer {\n    border-top: 1px solid #dddee0;\n    flex-direction: column;\n    padding-top: 32px;\n\n    .subtitle {\n      color: #6d717a;\n      font-size: 15px;\n      padding: 6px 0 16px;\n    }\n\n    .radioGroupLabel {\n      font-weight: 400;\n    }\n  }\n}\n\n.secondarySelectInput {\n  display: flex;\n  align-items: center;\n}\n\n.inputWrapper {\n  flex: 49% 0 1;\n  padding: 8px 0 0;\n}\n\n.inputInVisible {\n  display: none;\n}\n.inputWrapper_department {\n  flex: 49% 0 1;\n  padding: 8px 0 0;\n\n  div label {\n    z-index: 0;\n  }\n}\n\n.table {\n  margin: 20px 0 0;\n}\n\n.tableHead {\n  color: #1b2432 !important;\n  font-weight: 500 !important;\n  font-size: 15px !important;\n}\n\n.tableHead:nth-child(2) {\n  padding: 16px 4px 16px 0 !important;\n}\n\n.tableRow {\n  height: 68px !important;\n\n  &:last-child {\n    .tableCell {\n      border: none;\n    }\n  }\n\n  &.addNewTableRow {\n    border-bottom: 1px solid rgba(224, 224, 224, 1);\n  }\n}\n\n.tableCell {\n  font-size: 15px !important;\n  padding: 16px 16px 16px 24px !important;\n  min-width: unset !important;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 400px;\n\n  &.removeCell {\n    text-align: right;\n    padding: 0 !important;\n    width: 100px;\n    cursor: pointer;\n\n    button {\n      padding-left: 0;\n      padding-right: 0;\n    }\n\n    .button_more {\n      min-width: 10px;\n    }\n\n    .button_more:hover {\n      background-color: transparent !important;\n    }\n\n    .menuList {\n      font-size: 15px;\n      letter-spacing: 0;\n\n      li:first-child {\n        font-size: 15px;\n        color: #6d717a !important;\n      }\n\n      li:nth-child(3) {\n        font-size: 15px;\n        color: #fc3b60 !important;\n      }\n\n      svg {\n        margin-right: 5px;\n      }\n    }\n  }\n\n  &.inputTableCell {\n    padding: 16px 16px 16px 0 !important;\n    width: 250px;\n\n    > div {\n      margin-top: 0 !important;\n      margin-bottom: 0 !important;\n    }\n  }\n\n  &.buttonTableCell {\n    padding: 16px 0 !important;\n    text-align: right;\n    width: 160px;\n  }\n}\n\n.tableCell:nth-child(2) {\n  padding: 16px 16px 16px 0 !important;\n}\n\n.alertMessageCont {\n  display: flex;\n  flex-direction: column;\n\n  .alertMessage {\n    font-family: 'Roboto-Regular';\n    font-size: 11px;\n    color: #fc3b60 !important;\n    letter-spacing: 0;\n    margin-top: 4px;\n  }\n}\n\n.emptyData {\n  padding: 24px 0;\n}\n\n.selectWrapper {\n  width: 100%;\n}\n\n.cancel {\n  color: #6d717a;\n  margin-right: 12px;\n}\n\n.addHotel {\n  display: flex;\n  align-items: center;\n  color: #1e8aff !important;\n  font-size: 13px;\n  padding: 6px 0 18px 24px;\n  cursor: pointer;\n  &:hover {\n    color: #f6f6f7;\n  }\n  width: 100%;\n  font-weight: 500;\n}\n\n.addIcon {\n  height: 18px;\n  margin-right: 5px;\n}\n\n.close {\n  cursor: pointer;\n  display: none;\n\n  .icon {\n    color: rgba(0, 0, 0, 0.23);\n    font-size: 16px;\n    margin-right: 2px;\n  }\n}\n\n.loaderContainer {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.iconAndInfoContainer {\n  display: flex;\n  align-items: stretch;\n  justify-content: space-between;\n\n  .iconContainer {\n    margin-right: 24px;\n    margin-top: 4px;\n\n    .icon {\n      width: 32px;\n      height: 32px;\n    }\n  }\n\n  .titleStyle {\n    font-family: 'Roboto';\n    font-weight: 500;\n    font-size: 21px;\n    color: #1b2432;\n    letter-spacing: 0;\n    margin-bottom: 7px;\n    text-align: start;\n  }\n  .subtitleStyle {\n    font-family: 'Roboto';\n    font-weight: 400;\n    font-size: 13px;\n    color: #6d717a;\n    letter-spacing: 0;\n  }\n}\n\n.buttonContainer {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.userNameAndActionbuttonContaner {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.noBorder {\n  fieldset {\n    border: none !important;\n  }\n  margin: 0 !important;\n\n  div {\n    padding: 0 !important;\n    padding-left: 1px !important;\n    font-size: 17px;\n    font-weight: 600;\n  }\n}\n\n.popupButtonsContainer {\n  border-top: 1px solid #e0e2e6;\n  padding-top: 30px;\n  display: flex;\n  justify-content: flex-end;\n  button {\n    width: 150px;\n    height: 52px;\n    font-size: 17px;\n  }\n\n  button:first-child {\n    border: 1px solid #318afb !important;\n    border-radius: 6px;\n    font-size: 17px;\n    color: #318afb;\n    letter-spacing: 0;\n    text-align: center;\n    margin-right: 15px;\n  }\n\n  .cancelButton {\n    border: 1px solid #318afb;\n    border-radius: 6px;\n    font-size: 17px;\n    color: #318afb;\n    letter-spacing: 0;\n    text-align: center;\n    margin-right: 15px;\n  }\n}\n\n.addNewTableRowHotel {\n  margin-top: 20px;\n}\n\n.addHotelButtonLabel {\n  font-family: 'Roboto';\n  font-size: 13px;\n  color: #318afb;\n  letter-spacing: 0;\n  font-weight: 600;\n}\n\n.hotelTable {\n  td {\n    font-family: 'Roboto';\n  }\n  td:first-child {\n    font-weight: 600;\n  }\n}\n\n.item1 {\n  display: flex;\n}\n\n.pageWrapper {\n  width: 100%;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);\n}\n\n.tableCellFeature:nth-child(2) {\n  p {\n    margin: 0 !important;\n  }\n}\n\ntd {\n  p {\n    margin: 0 !important;\n  }\n}\n\n.preview {\n  border: 1px solid #dddee0;\n  padding: 6px;\n  width: 66px;\n  border-radius: 4px;\n  font-size: 13px;\n  width: fit-content;\n}\n\n.test {\n  border: 1px solid #dddee0;\n  padding: 6px;\n  width: 66px;\n  border-radius: 6px;\n  border-radius: 4px;\n  font-size: 13px;\n  background: rgba(252, 59, 59, 0.1);\n  width: fit-content;\n}\n\n.production {\n  background: rgba(18, 218, 159, 0.1);\n  border: 1px solid #12da9f;\n  border-radius: 4px;\n  font-size: 13px;\n  color: #1b2432;\n  letter-spacing: 0;\n  text-align: center;\n  padding: 6px;\n  width: fit-content;\n}\n\n.pending {\n  background: rgba(247, 158, 61, 0.1);\n  border: 1px solid #f79e3d;\n  border-radius: 4px;\n  font-size: 13px;\n  color: #1b2432;\n  letter-spacing: 0;\n  text-align: center;\n  padding: 6px;\n  width: fit-content;\n}\n\n.development {\n  background: rgba(252, 59, 59, 0.1);\n  border: 1px solid #fc3b60;\n  border-radius: 4px;\n  font-size: 13px;\n  color: #1b2432;\n  letter-spacing: 0;\n  text-align: center;\n  padding: 6px;\n  width: fit-content;\n  background: rgba(252, 59, 59, 0.1);\n}\n\n.staging {\n  border-radius: 4px;\n  font-size: 13px;\n  color: #1b2432;\n  letter-spacing: 0;\n  text-align: center;\n  padding: 6px;\n  width: fit-content;\n  background: rgba(247, 158, 61, 0.1);\n  border: 1px solid #f79e3d;\n}\n\n.emptyHead {\n  width: 30px;\n  padding: 0 !important;\n  min-width: unset !important;\n}\n\n.empty {\n  width: 30px;\n  padding: 0 !important;\n  border-bottom: none !important;\n  min-width: unset !important;\n}\n\n.tableHeadFeature {\n  border-bottom: 2px solid #e0e2e6;\n  box-shadow: 0 2px 4px 0 rgba(109, 113, 122, 0.15);\n  font-size: 13px;\n  color: #1b2432;\n  letter-spacing: 0;\n}\n\n.editFeatureButton {\n  width: 100%;\n}\n",null],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `components-ManageTB-Features-styles___paper--AZOyl`,
	"dropdown": `components-ManageTB-Features-styles___dropdown--cpgxD`,
	"root": `components-ManageTB-Features-styles___root--bBigH`,
	"menuItem": `components-ManageTB-Features-styles___menuItem--jKjEk`,
	"listItem": `components-ManageTB-Features-styles___listItem--wgWHA`,
	"location": `components-ManageTB-Features-styles___location--CzLyv`,
	"inputContainer": `components-ManageTB-Features-styles___inputContainer--C1XVB`,
	"passportInfo": `components-ManageTB-Features-styles___passportInfo--vmN46`,
	"inputContainerTravelerSelection": `components-ManageTB-Features-styles___inputContainerTravelerSelection--sWOjR`,
	"inputContainerTravelerSelectionOpen": `components-ManageTB-Features-styles___inputContainerTravelerSelectionOpen--bbEwJ`,
	"wrapperContainer": `components-ManageTB-Features-styles___wrapperContainer--tIrOI`,
	"subtitle": `components-ManageTB-Features-styles___subtitle--yw9_W`,
	"radioGroupLabel": `components-ManageTB-Features-styles___radioGroupLabel--Xonw8`,
	"secondarySelectInput": `components-ManageTB-Features-styles___secondarySelectInput--Z94FV`,
	"inputWrapper": `components-ManageTB-Features-styles___inputWrapper--QpD2r`,
	"inputInVisible": `components-ManageTB-Features-styles___inputInVisible--_xU0j`,
	"inputWrapperDepartment": `components-ManageTB-Features-styles___inputWrapper_department--dtgx3`,
	"table": `components-ManageTB-Features-styles___table--oq7ht`,
	"tableHead": `components-ManageTB-Features-styles___tableHead--kZFAp`,
	"tableRow": `components-ManageTB-Features-styles___tableRow--rlwh3`,
	"tableCell": `components-ManageTB-Features-styles___tableCell--Aqfkg`,
	"addNewTableRow": `components-ManageTB-Features-styles___addNewTableRow--w52nI`,
	"removeCell": `components-ManageTB-Features-styles___removeCell--GV4uw`,
	"buttonMore": `components-ManageTB-Features-styles___button_more--GGzOE`,
	"menuList": `components-ManageTB-Features-styles___menuList--NiVao`,
	"inputTableCell": `components-ManageTB-Features-styles___inputTableCell--pET7b`,
	"buttonTableCell": `components-ManageTB-Features-styles___buttonTableCell--_yj_c`,
	"alertMessageCont": `components-ManageTB-Features-styles___alertMessageCont--wAZdk`,
	"alertMessage": `components-ManageTB-Features-styles___alertMessage--Pni2j`,
	"emptyData": `components-ManageTB-Features-styles___emptyData--K2dFj`,
	"selectWrapper": `components-ManageTB-Features-styles___selectWrapper--t5J5V`,
	"cancel": `components-ManageTB-Features-styles___cancel--xQZ68`,
	"addHotel": `components-ManageTB-Features-styles___addHotel--xk6Ks`,
	"addIcon": `components-ManageTB-Features-styles___addIcon--FPHr_`,
	"close": `components-ManageTB-Features-styles___close--tJjiJ`,
	"icon": `components-ManageTB-Features-styles___icon--_3u56`,
	"loaderContainer": `components-ManageTB-Features-styles___loaderContainer--WxFH9`,
	"iconAndInfoContainer": `components-ManageTB-Features-styles___iconAndInfoContainer--cdXqW`,
	"iconContainer": `components-ManageTB-Features-styles___iconContainer--mt1PJ`,
	"titleStyle": `components-ManageTB-Features-styles___titleStyle--r5mfc`,
	"subtitleStyle": `components-ManageTB-Features-styles___subtitleStyle--d49nK`,
	"buttonContainer": `components-ManageTB-Features-styles___buttonContainer--KySqz`,
	"userNameAndActionbuttonContaner": `components-ManageTB-Features-styles___userNameAndActionbuttonContaner--ocppI`,
	"noBorder": `components-ManageTB-Features-styles___noBorder--LRnl5`,
	"popupButtonsContainer": `components-ManageTB-Features-styles___popupButtonsContainer--cQNTR`,
	"cancelButton": `components-ManageTB-Features-styles___cancelButton--NYFIV`,
	"addNewTableRowHotel": `components-ManageTB-Features-styles___addNewTableRowHotel--Rz2dC`,
	"addHotelButtonLabel": `components-ManageTB-Features-styles___addHotelButtonLabel--apYVG`,
	"hotelTable": `components-ManageTB-Features-styles___hotelTable--TfGJJ`,
	"item1": `components-ManageTB-Features-styles___item1--hKv6x`,
	"pageWrapper": `components-ManageTB-Features-styles___pageWrapper--Qp1qV`,
	"tableCellFeature": `components-ManageTB-Features-styles___tableCellFeature--Lrdes`,
	"preview": `components-ManageTB-Features-styles___preview--AEreF`,
	"test": `components-ManageTB-Features-styles___test--EdDDf`,
	"production": `components-ManageTB-Features-styles___production--IXpcN`,
	"pending": `components-ManageTB-Features-styles___pending--zqyQ4`,
	"development": `components-ManageTB-Features-styles___development--cfD78`,
	"staging": `components-ManageTB-Features-styles___staging--nmJAA`,
	"emptyHead": `components-ManageTB-Features-styles___emptyHead--Ulnwx`,
	"empty": `components-ManageTB-Features-styles___empty--VJcmt`,
	"tableHeadFeature": `components-ManageTB-Features-styles___tableHeadFeature--Dj3VD`,
	"editFeatureButton": `components-ManageTB-Features-styles___editFeatureButton--gWzoN`
};
module.exports = ___CSS_LOADER_EXPORT___;
